import React, {Component} from 'react';
import ListingsHeaderV2 from '../../MainListing/ListingsHeaderV2';
import {
  StyleSheet,
  View,
  Text,
  TextInput,
  ScrollView,
  Dimensions,
} from 'react-native';
import colors from '../../HelperClasses/AppColor';
import appConfigStyle from '../../StyleSheets/AppConfigStyleSheet';
import PropTypes from 'prop-types';
import tableStyle from '../../StyleSheets/TableCommonStyleSheet';
import networkService from '../../Network/NetworkManager';
import Appload from '../../HelperClasses/AppLoaderClasses/AppLoader';
import {AppToast} from '../../HelperClasses/AppToast';
import CommonStyleSheet from '../../StyleSheets/CommonStyleSheet';
import Switch from 'react-switch';
import {
  addMixpanelEvent,
  MixpanelEvent,
  MixPannelEnum,
} from '../../Models/MixPannelEnum';
import SaveButton from '../../Component/SaveButton';
import {ToastContainer} from 'react-toastify';
import {checkUserRoleModule} from '../../HelperClasses/SingletonClass';
import {MODULEKEYS} from '../../Models/Enum';
import {ThemeContext} from '../../HelperClasses/ThemeContext';
import {withLocale} from '../../Localization/LocaleContext';
import {clearAccountConfigurationDraft, readAccountConfigurationDraft, writeAccountConfigurationDraft} from '../../Localization/accountConfigurationDrafts';

const AppConstants = require('../../Constants/AppConstants');
const APPURL = require('../../Constants/URLConstants');

const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;
let fixedWidth = AppConstants.mobileMaxWidth;
let itsMobileView = windowWidth < fixedWidth ? true : false;

class AccountSetting extends Component {
  static contextType = ThemeContext;
  translate = (key, fallback) => this.props.localeContext?.translate?.(key, fallback) || fallback || key;
  constructor(props) {
    super(props);
    this.state = {
      dataLoad: false,
      accountDetailNote: '',
      addressLabel: '',
      categoryLabel: '',
      nearRadiusKm: '',
      accountLimit: '',
      statusArray: new Array(10).fill(false),
      shippingPreferenceNote: '',
      writeP: AppConstants.defaultWrite,
      readP: AppConstants.defaultWrite,
      deleteP: AppConstants.defaultDelete,
      regexp: /^[0-9\.]+$/,
      ...readAccountConfigurationDraft(),
      draftHydrated: false,
    };
  }

  static propTypes = {
    backBtn: PropTypes.func,
    fromRootScreen: PropTypes.bool,
  };

  componentDidMount() {
    this.initializeComponent();
  }
  componentDidUpdate(previousProps, previousState) {
    if (this.state.draftHydrated && previousState !== this.state) writeAccountConfigurationDraft(this.state);
  }

  initializeComponent = async () => {
    await Promise.all([this.loadConfigApi(), this.checkModule()]);
    addMixpanelEvent(MixpanelEvent.viewAccountConfigurations);
  };

  checkModule = () => {
    checkUserRoleModule(MODULEKEYS.ACCOUNTSCONFIGURATION, res => {
      this.setState({
        readP: res[0],
        writeP: res[1],
        deleteP: res[2],
      });
    });
  };

  loadConfigApi = async () => {
    try {
      const responseJson = await networkService.networkCall(
        `${APPURL.URLPaths.config}?key_group=accounts`,
        'get',
      );

      if (!responseJson.status) {
        this.setState({dataLoad: true, draftHydrated: true});
        return;
      }

      const {configs} = responseJson.data;

      // Update text fields
      const textFields = {
        accountDetailNote: configs.account_detail_note || '',
        addressLabel: configs.account_address_label || '',
        categoryLabel: configs.account_category_label || '',
        nearRadiusKm: configs.near_by_accounts_radius_km || '',
        accountLimit: configs.account_limit || '',
        shippingPreferenceNote: configs.shipping_methods_preference_note ?? '',
      };

      // Update status array
      const statusUpdates = [
        configs.account_auto_approval || false,
        configs.enable_shipping_methods_preference || false,
        configs.account_map_location_selector_enabled || false,
        configs.account_address_enabled || false,
        configs.enable_account_slug || false,
        configs.show_description ?? true,
        configs.account_enable_formatted_text_description ?? true,
        configs.hide_address_from_account_detail ?? false,
        configs.get_account_pickup_address_always ?? false,
        configs.get_pickup_address_for_delivery ?? false,
      ];

      this.setState({
        ...textFields,
        statusArray: statusUpdates,
        ...readAccountConfigurationDraft(),
        dataLoad: true,
        draftHydrated: true,
      });
    } catch (error) {
      console.error('Error loading config:', error);
      this.setState({dataLoad: true, draftHydrated: true});
    }
  };

  addOrUpdateApi = async () => {
    this.setState({dataLoad: false});
    var configs = [];

    // Add text field configs
    var valueArray = [
      this.state.accountDetailNote,
      this.state.addressLabel,
      this.state.categoryLabel,
      this.state.nearRadiusKm,
      this.state.shippingPreferenceNote,
      this.state.accountLimit,
    ];

    for (let a = 0; a < valueArray.length; a++) {
      if (valueArray[a].length != 0) {
        let fDict = {
          key_group: 'accounts',
          key: keyStringArray[a],
          value: valueArray[a],
          secured: false,
        };
        configs.push(fDict);
      }
    }

    // Add boolean configs
    for (let i = 0; i < keyParameterArray.length; i++) {
      let fDict = {
        key_group: 'accounts',
        key: keyParameterArray[i],
        value: this.state.statusArray[i],
        secured: false,
      };
      configs.push(fDict);
    }

    try {
      const responseJson = await networkService.networkCall(
        APPURL.URLPaths.config,
        'post',
        JSON.stringify({configs: configs}),
      );

      if (responseJson.status) {
        this.mixpanelInfo(true);
        await this.deleteKeysAPI(configs);
      } else {
        this.mixpanelInfo(false);
        this.setState({dataLoad: true});
      }
    } catch (error) {
      console.error('Error updating config:', error);
      this.mixpanelInfo(false);
      this.setState({dataLoad: true});
    }
  };

  mixpanelInfo(resp) {
    let properties = {success: resp};
    addMixpanelEvent(MixpanelEvent.accountConfigurationSaved, properties);
  }

  deleteKeysAPI = async Parameter => {
    var deleteParms = [];
    var deleteIndex = [];
    for (let q = 0; q < commonKeyStringArray.length; q++) {
      deleteParms.push(commonKeyStringArray[q]);
    }
    for (let a = 0; a < Parameter.length; a++) {
      let name = Parameter[a]['key'];
      let index = deleteParms.indexOf(name);
      deleteParms.splice(index, 1);
      //deleteIndex.push(index);
    }
    // for (let i = deleteIndex.length - 1; i >= 0; i--) {
    //   deleteParms.splice(deleteIndex[i], 1);
    // }
    let parms = deleteParms.toString();
    let urlParm = APPURL.URLPaths.config + '?key=' + parms;
    const responseJson = await networkService.networkCall(
      urlParm,
      'delete',
      '',
      '',
    );
    this.setState({dataLoad: true});
    if (responseJson?.status) {
      clearAccountConfigurationDraft();
      this.alertView('Uploaded successfully');
    } else {
      this.alertView(responseJson);
    }
  };

  alertView(title) {
    // if (Platform.OS === 'web') {
    //   alert(title);
    // } else {
    //   Alert.alert(title);
    // }
    AppToast(title === 'Uploaded successfully' ? this.translate('account_config.uploaded_successfully', 'Uploaded successfully') : title);
  }

  //MARK:-  Buttons Action Method 
  saveButtonAction() {
    this.setState({dataLoad: false});
    this.addOrUpdateApi();
  }

  switchSattusBtnAction(id) {
    this.state.statusArray[id] = !this.state.statusArray[id];
    this.setState({updateUI: !this.state.updateUI});
  }

  onHandleTextChange = text => {
    let value = text;
    if (text == '' || this.state.regexp.test(value)) {
      this.setState({nearRadiusKm: text});
    }
  };

  onHandleLimitChange = text => {
    let value = text;
    if (text == '' || this.state.regexp.test(value)) {
      this.setState({accountLimit: text});
    }
  };

  //MARK:-  UI 
  renderAllSwitches = props => {
    const themeColors = this.context?.colors ?? colors;
    var views = [];
    for (let i = 0; i < switchTitleStrings.length; i++) {
      views.push(
        <View
          style={{
            flexDirection: 'row',
            marginTop: 20,
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
          <View>
            <Text
              style={[
                CommonStyleSheet.titleNameStyle,
                {color: themeColors.primaryText},
              ]}>
              {this.translate(`account_config.option_${String(switchTitleStrings[i]).toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '')}`, switchTitleStrings[i])}
            </Text>
          </View>
          <View style={{width: '70%'}}>
            <Switch
              onColor={themeColors.AppNewGreen}
              onChange={() => this.switchSattusBtnAction(i)}
              checked={this.state.statusArray[i]}
              height={22}
              width={50}
            />
          </View>
        </View>,
      );
    }
    return views;
  };

  renderHeaderView = () => {
    const themeColors = this.context?.colors ?? colors;
    return (
      <ListingsHeaderV2
        simple={true}
        titleArea={<Text style={[tableStyle.titleTextStyle, {margin: 0, color: themeColors.primaryText}]}>{this.translate('account_config.title', 'Account Configuration')}</Text>}
        actionControl={
          <SaveButton
            saveBtn={() => this.saveButtonAction()}
            saveBtnTitle={this.translate('common.save', 'Save')}
            btnDeActive={!this.state.writeP || !this.state.deleteP}
            showLock={true}
          />
        }
      />
    );
  };

  render() {
    const {readP, dataLoad, fromRootScreen} = this.state;
    const themeColors = this.context?.colors ?? colors;

    return (
      <View
        style={[CommonStyleSheet.Container, {backgroundColor: themeColors.screenBackground}]}
        className="account-config-page">
        <this.renderHeaderView />
          <View
          style={[
            fromRootScreen
              ? tableStyle.containerMainView
              : tableStyle.listContainerView,
            {
              backgroundColor: themeColors.cardBackground,
              borderColor: themeColors.borderColor,
            },
          ]}>
          <ToastContainer />
          <ScrollView style={{backgroundColor: themeColors.cardBackground}}>
            {readP && this.renderForm()}
            <Appload enable={dataLoad} />
          </ScrollView>
        </View>
      </View>
    );
  }

  renderForm = () => {
    const themeColors = this.context?.colors ?? colors;
    return (
    <View style={CommonStyleSheet.configurationSubViewStyle}>
      <View style={{flexDirection: 'column', flex: 1}}>
        <View style={CommonStyleSheet.subViewStyle}>
          <Text style={[CommonStyleSheet.titleNameStyle, {color: themeColors.primaryText}]}>
            {this.translate('account_config.account_detail_note', 'Account detail note')}{' '}
          </Text>
          <TextInput
            style={[
              CommonStyleSheet.txtFieldStyle,
              {outline: 0, width: itsMobileView ? '100%' : '70%'},
            ]}
            placeholder={this.translate('account_config.enter_account_detail_note', 'Enter account detail note')}
            placeholderTextColor={colors.placeholderColor}
            onChangeText={text => this.setState({accountDetailNote: text})}
            value={this.state.accountDetailNote}
          />
        </View>
        <View style={{height: 20}} />
        <View style={CommonStyleSheet.subViewStyle}>
          <Text style={[CommonStyleSheet.titleNameStyle, {color: themeColors.primaryText}]}>{this.translate('account_config.address_label', 'Address label')} </Text>
          <TextInput
            style={[
              CommonStyleSheet.txtFieldStyle,
              {outline: 0, width: itsMobileView ? '100%' : '70%'},
            ]}
            placeholder={this.translate('account_config.enter_address_label', 'Enter address label')}
            placeholderTextColor={colors.placeholderColor}
            onChangeText={text => this.setState({addressLabel: text})}
            value={this.state.addressLabel}
          />
        </View>
        <View style={{height: 20}} />
        <View style={CommonStyleSheet.subViewStyle}>
          <Text style={[CommonStyleSheet.titleNameStyle, {color: themeColors.primaryText}]}> {this.translate('account_config.category_label', 'Category label')} </Text>
          <TextInput
            style={[
              CommonStyleSheet.txtFieldStyle,
              {outline: 0, width: itsMobileView ? '100%' : '70%'},
            ]}
            placeholder={this.translate('account_config.enter_category_label', 'Enter category label')}
            placeholderTextColor={colors.placeholderColor}
            onChangeText={text => this.setState({categoryLabel: text})}
            value={this.state.categoryLabel}
          />
        </View>
        <View style={{height: 20}} />
        <View style={CommonStyleSheet.subViewStyle}>
          <Text style={[CommonStyleSheet.titleNameStyle, {color: themeColors.primaryText}]}>
            {' '}
            {this.translate('account_config.nearby_accounts_radius_km', 'Near by accounts radius km')}{' '}
          </Text>
          <TextInput
            style={[
              CommonStyleSheet.txtFieldStyle,
              {outline: 0, width: itsMobileView ? '100%' : '70%'},
            ]}
            placeholder={this.translate('account_config.nearby_accounts_radius_placeholder', 'Account near by accounts radius km')}
            placeholderTextColor={colors.placeholderColor}
            onChangeText={text => this.onHandleTextChange(text)}
            value={this.state.nearRadiusKm}
          />
        </View>
        <View style={{height: 20}} />
        <View style={CommonStyleSheet.subViewStyle}>
          <Text style={[CommonStyleSheet.titleNameStyle, {color: themeColors.primaryText}]}> {this.translate('account_config.account_limit', 'Account Limit')} </Text>
          <TextInput
            style={[
              CommonStyleSheet.txtFieldStyle,
              {outline: 0, width: itsMobileView ? '100%' : '70%'},
            ]}
            placeholder={this.translate('account_config.account_limit_placeholder', 'Account limit')}
            placeholderTextColor={colors.placeholderColor}
            onChangeText={text => this.onHandleLimitChange(text)}
            value={this.state.accountLimit}
          />
        </View>
        <View style={{height: 20}} />
        <View style={[CommonStyleSheet.subViewStyle]}>
          <Text style={[CommonStyleSheet.titleNameStyle, {color: themeColors.primaryText}]}>
            {this.translate('account_config.shipping_preference_note', 'Shipping method preference note')}{' '}
          </Text>
          <TextInput
            style={[
              CommonStyleSheet.txtFieldStyle,
              {
                outline: 0,
                width: itsMobileView ? '100%' : '70%',
                minHeight: 120,
                paddingTop: 10,
              },
            ]}
            placeholder={this.translate('account_config.shipping_preference_note', 'Shipping method preference note')}
            placeholderTextColor={colors.placeholderColor}
            onChangeText={text => this.setState({shippingPreferenceNote: text})}
            value={this.state.shippingPreferenceNote}
            multiline={true}
          />
        </View>
        <View style={{paddingLeft: 20, paddingRight: 20}}>
          <this.renderAllSwitches />
        </View>
      </View>
    </View>
  );
  }
}

export default withLocale(AccountSetting);

const switchTitleStrings = [
  'Accounts auto approved',
  'Shipping methods preference for accounts',
  'Account map location selector',
  // 'Enable branch unique url',
  'Account Geo Location',
  'Slug',
  'Show Description',
  'Formatted Text Description',
  'Hide Address from Account Detail',
  'Get Account Pickup Address Always',
  'Get Pickup Address for Delivery',
];

let keyParameterArray = [
  'account_auto_approval',
  'enable_shipping_methods_preference',
  'account_map_location_selector_enabled',
  // 'enable_branch_unique_url',
  'account_address_enabled',
  'enable_account_slug',
  'show_description',
  'account_enable_formatted_text_description',
  'hide_address_from_account_detail',
  'get_account_pickup_address_always',
  'get_pickup_address_for_delivery',
];

let commonKeyStringArray = [
  'account_detail_note',
  'account_auto_approval',
  'enable_shipping_methods_preference',
  'account_map_location_selector_enabled',
  // 'enable_branch_unique_url',
  'account_address_label',
  'account_category_label',
  'near_by_accounts_radius_km',
  'shipping_methods_preference_note',
  'account_address_enabled',
  'enable_account_slug',
  'show_description',
  'account_enable_formatted_text_description',
  'hide_address_from_account_detail',
  'get_account_pickup_address_always',
  'get_pickup_address_for_delivery',
];

let keyStringArray = [
  'account_detail_note',
  'account_address_label',
  'account_category_label',
  'near_by_accounts_radius_km',
  'shipping_methods_preference_note',
  'account_limit',
];
